import React, { useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'

// Const
import { EVENT_LOCATION_CHANGE } from 'constants/events'

// Build-in popups
import PopupAlert from 'ui/PopupAlert'
import PopupConfirm from 'ui/PopupConfirm'

import event from 'services/event'

const create = (DialogComponent, props = {}) => {
  // Create a root
  const root = document.createElement('div')

  // Append root to body
  document.body.appendChild(root)

  const Modal = () => {
    const onLocationChange = useCallback(() => {
      ReactDOM.unmountComponentAtNode(root)
    }, [])

    useEffect(() => {
      event.on(EVENT_LOCATION_CHANGE, onLocationChange)

      return () => {
        event.off(EVENT_LOCATION_CHANGE, onLocationChange)
      }
    }, [onLocationChange])

    return <DialogComponent {...props} />
  }

  // Render dialog component inside that div
  ReactDOM.render(<Modal />, root)
}

const alert = (props = {}) => {
  return create(PopupAlert, props)
}

const confirm = (props = {}) => {
  return create(PopupConfirm, props)
}

export default {
  create,
  alert,
  confirm,
}
